import NewPasswordModule from '@/modules/new-password/NewPasswordModule';

export default NewPasswordModule;

